export default __webpack_public_path__ + "static/media/logo_ecf.370b6986.png";